// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"99f42b59","1420":"175b7be9","1645":"c81403ce","5790":"822314a0","9801":"95f5cf02"}[chunkId] + ".chunk.css";
};